// tutorial: i plugins sono interceptors di ogni mutation che viene committata
export default (vuexstore: any) => {
    vuexstore.subscribe((mutation: any, state: any) => {
        const isMulticarrier = state.options.carrier.multicarrier;
        if (mutation.type === 'checkout/setSelectedShipment') {
            if (mutation.payload !== state.options.carrier.pickup_method) {
                vuexstore.dispatch('storelocator/deleteStore');
            }
            if (mutation.payload !== 'pickuppoints_pickuppoints') {
                vuexstore.dispatch('pickuppoint/deletePickupPoint');
            }
        }

        if (isMulticarrier && mutation.type === 'checkout/goingToStep'
            && mutation.payload.toStep === 'shipping'
            && state.checkout.shippingMethods.length === 0
        ) {
            vuexstore.dispatch('checkout/estimateShipping', state.checkout.billingAddress);
        }
    });
};
